<app-action-modal
  #actionModal
  [disabled]="submitted"
  [showHeader]="true"
  submitButtonClass="lty-btn-primary"
  headerIconState="success"
  customModalClass="cancellation-send-modal"
  (submitted)="confirm()"
>
  <div class="d-flex" headerIcon>
    <app-send-icon height="20px" width="20px" color="var(--success-500)" />
  </div>
  <span class="cancellation-send-modal__title" mainTitle i18n
    >Marquer la lettre comme envoyée</span
  >
  <ng-container subtitle i18n
    >Confirmez que vous avez vous-même transmis la lettre de résiliation signée
    à l'assureur.</ng-container
  >
  <ng-container submitButtonLabel i18n>Confirmer</ng-container>
</app-action-modal>
